import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

import { Grid, Row, Col, Typography } from '@sm/wds-react';
import { DesktopScreen } from '@sm/webassets';
import { T } from '@sm/intl';

import useBrowser, { BROWSER } from '../../helpers/useBrowser';
import { SCREEN } from '../../sharedComponents/CustomScreen';
import getLocalizedLogos from './getLocalizedLogos';
import './used-in-orgs.scss';

export const COPY = {
  title: {
    id: 'mrx.UsedInOrgs.title',
    defaultMessage: 'Leading brands use SurveyMonkey for market research',
    description:
      '[Type: Header][Vis: med] - Title of the section of the market research hub where we show companies that use our products',
  },
};

export const TEST_ID = 'UsedInOrgs';

const UsedInOrgs = () => {
  const [logos, setLogos] = useState(null);
  const [screenSize, setScreenSize] = useState('lg');
  useEffect(() => {
    const listenerArgs = [
      'resize',
      () => {
        const isMobileTablet = window.matchMedia(SCREEN.MOBILE).matches;
        if (isMobileTablet && screenSize !== 'sm') setScreenSize('sm');
        else if (screenSize !== 'lg') setScreenSize('lg');
      },
    ];
    window.addEventListener(...listenerArgs);
    getLocalizedLogos('en_US', screenSize).then(data => setLogos(data));
    return () => window.removeEventListener(...listenerArgs);
  }, [screenSize]);
  const isIE = useBrowser() === BROWSER.IE;
  return (
    <Grid noBleeds noGutters fluid className="sm-used-in-orgs" data-testid={TEST_ID}>
      <Row className="sm-used-in-orgs__title-row">
        <DesktopScreen>
          <Col lg={1} xl={3} />
        </DesktopScreen>
        <Col>
          <Typography align="center" component="h2" className="sm-used-in-orgs__title">
            <T desc={COPY.title} />
          </Typography>
        </Col>
        <DesktopScreen>
          <Col lg={1} xl={3} />
        </DesktopScreen>
      </Row>
      <If condition={logos}>
        <Row>
          {logos.map(logo => (
            <Col
              key={logo.id}
              className={classnames({
                'sm-used-in-orgs__logo-wrapper': true,
                'sm-used-in-orgs__logo-wrapper--ie': isIE,
              })}
            >
              <img className="sm-used-in-orgs__logo" src={logo.image} alt={logo.name} />
            </Col>
          ))}
        </Row>
      </If>
    </Grid>
  );
};

export default UsedInOrgs;
